import { useId } from 'preact/hooks';
import { potionArt, potionArtMask } from '../../utils/arena/alchemist';
import { POTION_LIQUID } from './potionLiquid';
import PotionBrewGlow from './PotionBrewGlow';

export default function PotionArtwork({ potion, known, brew }) {
  const id = useId();
  const liquid = POTION_LIQUID[potion];
  return (
    <svg data-testid="potion-art" aria-hidden viewBox="0 0 1024 1024" className="vh-potion-artwork"
      style={{ maskImage: potionArtMask(potion), maskSize: '100% 100%', filter: known ? 'none' : 'grayscale(0.7)' }}>
      <defs>
        <path id={`${id}-volume`} d={liquid.d} fillRule="evenodd" />
        <clipPath id={`${id}-liquid`}><use href={`#${id}-volume`} clipRule="evenodd" /></clipPath>
        <clipPath id={`${id}-shell`}>
          <path d={`M0 0H1024V1024H0Z ${liquid.d}`} clipRule="evenodd" />
        </clipPath>
      </defs>
      {/* The shell has actual holes where the liquid belongs. Hiding the liquid
          leaves those holes visible: it is no longer baked into the bench image. */}
      <image data-testid="potion-shell-layer" href={potionArt(potion)} width="1024" height="1024" clipPath={`url(#${id}-shell)`} />
      <g data-testid="potion-liquid-layer" data-potion={potion}>
        <image href={potionArt(potion)} width="1024" height="1024" clipPath={`url(#${id}-liquid)`} />
        {brew ? <PotionBrewGlow potion={potion} materialId={id} brew={brew} /> : null}
      </g>
    </svg>
  );
}
